// Funny loading messages for podcast processing
export const FUNNY_LOADING_MESSAGES = [
	"Brewing some fresh audio...",
	"Teaching computers to read...",
	"Turning interesting into brilliant...",
	"Asking AI to be creative...",
	"Talking to our Agents...",
	"Warming up the voice actors...",
	"Translating academic to human...",
	"Sprinkling some magic dust...",
	"Consulting the podcast gods...",
	"Organizing scattered thoughts...",
	"Making science sound even more fun...",
	"Bribing the servers with cookies...",
	"Stretching our digital legs...",
	"Counting to a million... slowly...",
	"Teaching robots to sound excited...",
	"Converting coffee into content...",
	"Untangling headphone cables...",
	"Polishing the audio vibes...",
	"Downloading more patience...",
	"Herding digital cats...",
	"Procrastinating productively...",
	"Almost there... probably...",
	"Still working, we promise...",
	"Perfecting the podcast sauce...",
	"Herding some virtual cows...",
	"Worth the wait, trust us...",
	"Finding the perfect story to start your episode...",
	"Turning good thoughts into great conversation...",
	"Making sure the audio sounds shiny...",
	"Petting some virtual sheep...",
	"Storyline for the storytime...",
	"Going from good to great...",
	"Packing your episode with just the right amount of chaos...",
	"Letting the ideas stretch before they go on air...",
	"Collecting stories that didn’t hit snooze...",
	"Giving this episode a little extra sparkle...",
	"Chasing runaway thoughts back into the script...",
	"Convincing the AI to keep this one under three hours...",
];
